import type { FC } from "react";

import { t } from "i18n/i18n";
import { Button } from "mds/components/Button";
import { Menu, MenuDivider, MenuItem } from "mds/components/Menu";
import { ChevronDownIcon } from "mds/icons";

interface LateSubmissionIntervalDropdownProps {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  portal?: boolean;
}

export const LateSubmissionIntervalDropdown: FC<LateSubmissionIntervalDropdownProps> = ({
  value,
  onChange,
  disabled = false,
  portal,
}) => {
  const menuProps = portal !== undefined ? { portal } : {};
  return (
    <Menu
      {...menuProps}
      menuButton={
        <Button className="gap-1 text-xs" disabled={disabled} kind="white" size="xs">
          {value === Infinity ? t("timedelta.indefinite") : t("timedelta.days", { count: value })}
          <ChevronDownIcon />
        </Button>
      }
    >
      <MenuItem checked={value === Infinity} onClick={() => onChange(Infinity)}>
        {t("timedelta.indefinite")}
      </MenuItem>

      <MenuDivider />
      {[1, 2, 3, 4, 5, 6, 7].map((i) => (
        <MenuItem checked={value === i} key={i} onClick={() => onChange(i)}>
          {t("timedelta.days", { count: i })}
        </MenuItem>
      ))}
    </Menu>
  );
};
